import { Checkbox } from 'antd';
import CustomDropdown from 'components/dropdown/custom_select';
import { FormikProps } from 'formik';
import useMember from 'hooks/useMember';
import { useEffect, useState } from 'react';
import { vacationSchedule } from 'utils';

type RulesProps = {
  user?: any;
  onUpdateData?: (data: object) => void;
  formik?: FormikProps<any>;
};

const Rules = ({ user, onUpdateData, formik }: RulesProps) => {
  const [state, setState] = useState({
    staffLeaveData: [{ label: '', value: '' }],
    data: user,
  });
  const { getStaffLeaveListOption } = useMember();
  const { staffLeaveData, data } = state;

  useEffect(() => {
    getStaffLeaveListOption().then((res) => {
      setState((pre) => ({
        ...pre,
        staffLeaveData: res?.data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        }),
      }));
    });
  }, []);

  useEffect(() => {
    setState((pre) => ({
      ...pre,
      data: user,
    }));
  }, [user]);

  return (
    <div>
      <h1 style={{ fontWeight: 500, fontSize: 20, color: '#000000' }}>
        Staff Leave & Absence Management
      </h1>
      <div style={{ width: '100%', marginTop: 32 }}>
        <CustomDropdown
          disabled={formik?.values?.absence_policy_id}
          defaultKey={formik?.values?.absence_policy_id}
          width="100%"
          height={50}
          showIconWhenDisabled
          fontSize={12}
          defaultBorder="6px"
          title="Staff Leave/Absence Profile"
          options={staffLeaveData}
          onSelect={(v: string) => {
            if (v) {
              formik.setFieldValue('absence_policy_id', v);
            }
          }}
        />
      </div>
      <h1
        style={{
          marginTop: 32,
          fontWeight: 500,
          fontSize: 20,
          color: '#000000',
        }}
      >
        Visibility on vacation schedule
      </h1>
      <div style={{ marginTop: '40px' }}>
        <Checkbox.Group
          style={{ gap: 150 }}
          defaultValue={['User']}
          options={vacationSchedule}
        />
      </div>
    </div>
  );
};

export default Rules;
